import { ButtonSelectionCard, Text, DynamicGrid } from "@trailhead/asurion-ui";
import styled from "styled-components";
import React, { useEffect, useRef } from "react";


import {
  ATTIcon,
  CoxIcon,
  KoodoIcon,
  LibertyIcon,
  TelusIcon,
  USCellularIcon,
  VerizonIcon,
} from "./icons";
import { useNavigate } from "@trailhead/smart-setup-core";
import { Key, storage } from "@soluto-private/mx-context";
import { trackEvent } from "@trailhead/analytics";
import { PartnerType } from "@trailhead/contentful";
import { useSanitizedTranslation } from "@trailhead/i18n";
import { FlexColumnContainer, useWindowDimensions } from "@trailhead/core-ui";
import { updateMxHeader } from "@trailhead/mx-header";
import { useMxContext } from "@trailhead/mx-context";

const ClientPickerContainer = styled(FlexColumnContainer)`
  max-width: 768px;
  margin: 0 auto;
  gap: 2rem;
`;

const ClientHeader = styled(Text)`
  text-align: center;
`;

const CardWrapper = styled(ButtonSelectionCard)`
  height: 72px;
`;

const CLIENT_PICKER_BREAKPOINT = 481;

export const ClientPicker: React.FC = () => {
  const selectedClient = useRef("");
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const options = [
    { label: <ATTIcon />, value: PartnerType.ATT },
    { label: <CoxIcon />, value: PartnerType.COX },
    { label: <KoodoIcon />, value: PartnerType.KOODO },
    { label: <LibertyIcon />, value: PartnerType.LIBERTY },
    { label: <TelusIcon />, value: PartnerType.TELUS },
    { label: <USCellularIcon />, value: PartnerType.US_CELLULAR },
    { label: <VerizonIcon />, value: PartnerType.VERIZON },
  ];

  const t = useSanitizedTranslation();

  const { client } = useMxContext();

  const hubUrl = "https://my.asurion.com";

  useEffect(() => {
    trackEvent("Page_Loaded", { pageName: "Partner_Picker_Screen" });
  }, []);

  updateMxHeader({
    view: "service-view",
    title: t("Mobile Device Set Up"),
    homePath: hubUrl,
    client,
  });

  const dynamicGridProps =
    width >= CLIENT_PICKER_BREAKPOINT
      ? { minWidth: 7, maxColumns: 2, maxRows: Math.ceil(options.length / 2) }
      : { minWidth: 7, maxColumns: 1, maxRows: options.length };

  return (
    <ClientPickerContainer>
      <ClientHeader size={5} weight={"feather"}>
        {t("Who is your service provider?")}
      </ClientHeader>
      <DynamicGrid {...dynamicGridProps}>
        {options.map(option => (
          <CardWrapper
            disableSvgColorOverride={true}
            name="partnerPicker"
            value={option.value}
            data-testid={`partner-picker-option-${option.value}`}
            onClick={e => {
              selectedClient.current =
                (e.target as HTMLInputElement).value || option.value;
              trackEvent("Partner_Selected", {
                partnerSelection: `${selectedClient.current}`,
              });
              storage.set(Key.Client, selectedClient.current);
              navigate(
                `/mobile-device-setup/setup?mxclient=${selectedClient.current}`,
              );
            }}
          >
            {option.label}
          </CardWrapper>
        ))}
      </DynamicGrid>
    </ClientPickerContainer>
  );
};
